import { Comments } from "../../../../components";
import { Button } from "../../../../shared";
import { Box, Divider, Typography } from "@mui/joy";
import { ChevronRight } from "lucide-react";

interface ITaskAction {
    taskName: string;
    onComplete: () => void;
    actionProgress?: any;
    isNextEligible?: boolean;
    taskId?: string;
}

export default function TaskAction(props: ITaskAction) {
    const { taskName, onComplete, actionProgress, isNextEligible, taskId } = {
        ...props,
    };

    const handleOnClose = () => {
        onComplete();
    };

    return (
        <Box sx={{ mt: 3, mb: 4 }}>
            <Box>
                <Typography
                    level="title-sm"
                    sx={{
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                        color: "neutral.500",
                        mb: 1.5,
                        fontSize: "11px",
                        fontWeight: 600,
                    }}
                >
                    Comments & Notes
                </Typography>
                <Comments entityType="task" entityId={taskId} />
            </Box>

            <Divider sx={{ my: 2 }} />
            <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        justifyContent: "space-between",
                        alignItems: { xs: "stretch", sm: "flex-end" },
                        gap: { xs: 2, sm: 3 },
                        width: "100%",
                    }}
                >
                    <Box sx={{ minWidth: 0, flex: 1 }}>
                        <Typography level="title-lg" sx={{ mb: 0.5 }}>
                            Task Completion
                        </Typography>
                        <Typography level="body-sm" color="neutral">
                            Review all fields and add any final notes before
                            completing the {taskName} task.
                        </Typography>
                    </Box>

                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: { xs: "stretch", sm: "flex-end" },
                            flexShrink: 0,
                            width: { xs: "100%", sm: "auto" },
                        }}
                    >
                        <Button
                            endDecorator={<ChevronRight size={18} />}
                            variant="solid"
                            color="primary"
                            onClick={handleOnClose}
                            loading={actionProgress?.loading}
                            loadingPosition="start"
                            disabled={!isNextEligible}
                            sx={{
                                width: { xs: "100%", sm: "auto" },
                                borderRadius: 0,
                                px: { xs: 2, sm: 4 },
                                whiteSpace: "nowrap",
                            }}
                        >
                            Save & Continue
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}
